export default __webpack_public_path__ + "static/media/logo-light.8138b1c3.png";